module.exports = __webpack_public_path__ + "static/media/tavolacalda profilo.651bb6b9.svg";